<template>
    <footer class="footer">
        <p class="fs-11 text-muted fw-medium text-uppercase mb-0 copyright">

        </p>
        <div class="d-flex align-items-center gap-4">
            <span>COPYRIGHT © <a href="https://kayrem.com" target="_blank">KAYREM</a></span>
            2025
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style scoped>
.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0 20px;
    text-align: center;
    z-index: 100;
    /* opacity: 0.5; */
}

body {
    margin-bottom: 60px;
    /* Footer'ı sayfanın içeriğiyle çakışmaması için alt kısıma padding ekler */
}
</style>